import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const ChunkNavContainer = styled(FlexView)`
  margin-bottom: 16px;
  padding: 16px;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.GREY_2};
  border-radius: 8px;
  gap: 12px;
`;

export const TopRow = styled(FlexView)`
  justify-content: space-between;
`;

export const ThumbnailsRow = styled(FlexView)`
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const NavButtons = styled(FlexView)`
  flex-shrink: 0;
  gap: 8px;
`;

export const PageIndicator = styled.span`
  min-width: 32px;
  text-align: center;
`;

export const NavButton = styled.button`
  padding: 6px 10px;
  border: none;
  background: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
